<template>
  <div class="earn-box bg-white elevation-1">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p
      class="text-p-title"
      v-html="title"
    ></p>
    <div
      v-if="loading"
      class="skeleton-text mt-3"
    ></div>
    <h2
      v-else
      class="count-text blue mt-2"
    >
      {{ value }}
    </h2>
  </div>
</template>

<script>
export default {
	name: 'SummaryCard',
	props: {
		title: {
			type: String,
			required: true,
		},
		value: {
			type: [String, Number],
			default: '12,000,00',
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style lang="scss" scoped>
.earn-box {
	background-color: #fff;
	padding: 40px 30px;
	border-radius: 30px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
	}
}

.blue {
	background: linear-gradient(135deg, #0b2240 0%, #1f4978 50%, var(--v-primary-base) 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	display: inline-block;
	font-weight: bold;
}

.text-p-title {
	color: #767676;
	font-weight: 500;
	font-size: 15px;
	line-height: 1.4;
	margin: 0;
}

.count-text {
	font-size: 32px;
	font-weight: 700;
	letter-spacing: -0.5px;
}

.skeleton-text {
	height: 38px;
	width: 140px;
	background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%);
	background-size: 200% 100%;
	animation: loading-pulse 1.5s infinite;
	border-radius: 8px;
}

@keyframes loading-pulse {
	0% {
		background-position: 200% 0;
	}
	100% {
		background-position: -200% 0;
	}
}
</style>
